import { Hourglass } from "lucide-react";
import { COMP_LABELS, REC } from "@/lib/fit";
import { cn } from "@/lib/utils";

export const ProvisionalTag = ({ testId, className }) => (
  <span data-testid={testId} title="Some parts of the Fit Score are still missing"
    className={cn("ml-1.5 inline-flex items-center rounded-full border border-[#E8D7B0] bg-caution-tint px-1.5 py-0 align-middle font-sans text-[10px] font-semibold text-caution", className)}>
    Provisional
  </span>
);

export const waitingOn = (missing) => (missing || []).map((k) => COMP_LABELS[k]?.toLowerCase() || k).join(", ");

export const WaitingOn = ({ missing, testId }) => missing?.length ? (
  <p data-testid={testId} className="inline-flex items-center gap-1.5 text-xs text-ink-secondary">
    <Hourglass size={12} aria-hidden="true" /> Waiting on: {waitingOn(missing)}
  </p>
) : null;

export const LeaningChip = ({ rec, testId }) => rec ? (
  <span data-testid={testId} className="inline-flex items-center whitespace-nowrap rounded-full border border-dashed border-line bg-white px-2.5 py-0.5 text-xs font-medium text-ink-secondary">
    Leaning: {REC[rec][0]}
  </span>
) : <span className="text-xs text-ink-muted">—</span>;
